"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NumberValuesEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _NavTab = _interopRequireDefault(require("@cimpress/react-components/lib/NavTab"));

var _NavTabItem = _interopRequireDefault(require("@cimpress/react-components/lib/NavTabItem"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _propTypes2 = require("../../shared/propTypes");

var _operators = require("../../shared/enums/operators");

var _options = require("../../shared/enums/options");

var _NumberValueEditor = require("../NumberValueEditor/NumberValueEditor");

var _RangeValuesEditor = require("../RangeValuesEditor/RangeValuesEditor");

var _FormulaValueEditor = require("../FormulaValueEditor/FormulaValueEditor");

var _messages = _interopRequireDefault(require("../../shared/messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var productOptionPropType = _propTypes["default"].shape(_propTypes2.optionShape);

var productPropertyPropType = _propTypes["default"].shape(_propTypes2.propertyShape);

var NumberValuesEditor = function NumberValuesEditor(_ref) {
  var condition = _ref.condition,
      attributes = _ref.attributes,
      selectedAttribute = _ref.selectedAttribute,
      selectedOperator = _ref.selectedOperator,
      allowFormulas = _ref.allowFormulas,
      onUpdateConditionValues = _ref.onUpdateConditionValues,
      formatMessage = _ref.intl.formatMessage;

  var shouldShowRangeEditor = function shouldShowRangeEditor(selectedOperator) {
    return !selectedOperator || selectedOperator === _operators.OPERATOR_TYPES.IN || selectedOperator === _operators.OPERATOR_TYPES.NOT_IN;
  };

  var defaultSelectionType = shouldShowRangeEditor(selectedOperator) ? _options.RANGE : _options.VALUE;

  var _useState = (0, _react.useState)(condition.values[0] ? condition.values[0].type : defaultSelectionType),
      _useState2 = _slicedToArray(_useState, 2),
      selectionType = _useState2[0],
      setSelectionType = _useState2[1];

  var _useState3 = (0, _react.useState)(selectedOperator),
      _useState4 = _slicedToArray(_useState3, 2),
      oldSelectedOperator = _useState4[0],
      setOldSelectedOperator = _useState4[1];

  (0, _react.useEffect)(function () {
    if (selectionType !== _operators.FORMULA && oldSelectedOperator !== selectedOperator) {
      if (defaultSelectionType !== selectionType) {
        if (defaultSelectionType === _options.RANGE) {
          onRangeTabSelect();
        } else {
          onNumberTabSelect();
        }
      }

      setOldSelectedOperator(selectedOperator);
    }
  }, [defaultSelectionType, selectionType, oldSelectedOperator, selectedOperator]); // eslint-disable-line react-hooks/exhaustive-deps

  var onRangeTabSelect = function onRangeTabSelect() {
    onUpdateConditionValues([]);
    setSelectionType(_options.RANGE);
  };

  var onNumberTabSelect = function onNumberTabSelect() {
    onUpdateConditionValues([]);
    setSelectionType(_options.VALUE);
  };

  var onFormulaTabSelect = function onFormulaTabSelect() {
    onUpdateConditionValues([]);
    setSelectionType(_operators.FORMULA);
  };

  var renderEditor = function renderEditor(selectionType) {
    if (selectionType === _options.RANGE) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_RangeValuesEditor.RangeValuesEditor, {
          values: condition.values,
          attribute: selectedAttribute,
          onValuesChanged: onUpdateConditionValues
        })
      );
    } else if (selectionType === _operators.FORMULA) {
      var value = condition.values.length > 0 ? condition.values[0] : {
        type: _operators.FORMULA
      };
      var variableNames = (0, _filter["default"])((0, _keys["default"])((0, _pickBy["default"])(attributes, function (attribute) {
        return attribute.type === _options.NUMBER;
      })), function (variableKey) {
        return variableKey !== condition.attribute;
      });
      return (
        /*#__PURE__*/
        _react["default"].createElement(_FormulaValueEditor.FormulaValueEditor, {
          value: value,
          variableNames: variableNames,
          onValueChanged: function onValueChanged(updatedValue) {
            return onUpdateConditionValues([updatedValue]);
          }
        })
      );
    } else if (selectionType === _options.VALUE) {
      var _value = condition.values.length > 0 ? condition.values[0] : {
        type: _options.VALUE
      };

      return (
        /*#__PURE__*/
        _react["default"].createElement(_NumberValueEditor.NumberValueEditor, {
          value: _value,
          attribute: selectedAttribute,
          onValueChanged: function onValueChanged(updatedValue) {
            return onUpdateConditionValues([updatedValue]);
          }
        })
      );
    }

    return null;
  };

  var showRangeEditor = shouldShowRangeEditor(selectedOperator);
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_NavTab["default"], null,
    /*#__PURE__*/
    _react["default"].createElement(_NavTabItem["default"], {
      active: selectionType === _options.RANGE,
      style: {
        display: showRangeEditor ? 'inherit' : 'none'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      onClick: onRangeTabSelect
    }, formatMessage(_messages["default"].ranges))),
    /*#__PURE__*/
    _react["default"].createElement(_NavTabItem["default"], {
      active: selectionType === _options.VALUE,
      style: {
        display: showRangeEditor ? 'none' : 'inherit'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      onClick: onNumberTabSelect
    }, formatMessage(_messages["default"].number))), allowFormulas ?
    /*#__PURE__*/
    _react["default"].createElement(_NavTabItem["default"], {
      active: selectionType === _operators.FORMULA
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      onClick: onFormulaTabSelect
    }, formatMessage(_messages["default"].formula))) : null), renderEditor(selectionType))
  );
};

exports.NumberValuesEditor = NumberValuesEditor;
NumberValuesEditor.propTypes = {
  selectedAttribute: _propTypes["default"].oneOfType([productOptionPropType, productPropertyPropType]).isRequired,
  selectedOperator: _propTypes["default"].string,
  condition: _propTypes["default"].shape(_propTypes2.constraintConditionShape).isRequired,
  attributes: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([productOptionPropType, productPropertyPropType])).isRequired,
  allowFormulas: _propTypes["default"].bool,
  onUpdateConditionValues: _propTypes["default"].func.isRequired,
  intl: _propTypes["default"].shape(_propTypes2.intlShape).isRequired
};
NumberValuesEditor.defaultProps = {
  selectionType: undefined,
  selectedOperator: undefined,
  allowFormulas: true
};

var _default = (0, _reactIntl.injectIntl)(NumberValuesEditor);

exports["default"] = _default;